// app/(routes)/tools/ai-for-financial-advisors/firmLookupQueryPolicy.ts

export const FIRM_LOOKUP_MIN_CHARS = 2;
export const FIRM_LOOKUP_DEBOUNCE_MS = 250;

export function normalizeFirmLookupQuery(query: string): string {
  return query.trim();
}

export function firmLookupQueryKey(normalizedQuery: string) {
  return ["workflow-finder", "firms", normalizedQuery] as const;
}

export function isFirmLookupEnabled(input: {
  hasSelectedFirm: boolean;
  usingManualProfile: boolean;
  normalizedQuery: string;
}): boolean {
  return (
    !input.hasSelectedFirm &&
    !input.usingManualProfile &&
    input.normalizedQuery.length >= FIRM_LOOKUP_MIN_CHARS
  );
}
